import type { SettingDefinition, SettingOption, SettingsSource } from '../models/settings-hub.model';

const paymentClassOptions = (): SettingOption[] => [
    { value: null, label: 'PAYMENT_CLASSES.NONE' },
    { value: 'cash', label: 'PAYMENT_CLASSES.CASH' },
    { value: 'digital', label: 'PAYMENT_CLASSES.DIGITAL' },
    { value: 'ticket', label: 'PAYMENT_CLASSES.TICKET' },
    { value: 'prepaid', label: 'PAYMENT_CLASSES.PREPAID' },
    { value: 'pms', label: 'PAYMENT_CLASSES.PMS' }
].map(option => ({ ...option, translate: true }));

const fastPaymentSettings: SettingDefinition[] = ([1, 2, 3] as const).flatMap(button => [
    {
        id: `cashregister.fast_payment_${button}_type`,
        preferenceKey: `cashregister.fast_payment_${button}_type`,
        pair: `fast_payment_${button}`,
        control: 'select',
        label: 'SETTINGS.SETTINGS.METHOD',
        options: paymentClassOptions
    },
    {
        id: `cashregister.fast_payment_${button}_label`,
        preferenceKey: `cashregister.fast_payment_${button}_label`,
        pair: `fast_payment_${button}`,
        control: 'text',
        label: 'SETTINGS.SETTINGS.LABEL'
    }
]);

export const PAYMENTS_SUBCATEGORY: SettingsSource = {
    id: 'payments',
    cards: [
        {
            id: 'fast-payments',
            settings: fastPaymentSettings
        },
        {
            id: 'payment-methods',
            settings: [
                { id: 'payment-methods', control: 'component', componentId: 'payment-methods', label: 'SETTINGS.SETTINGS.PAYMENT_METHODS' }
            ]
        }
    ]
};
